import { NgModule } from '@angular/core';
import { LongOperationModule } from 'src/app/common/long-operations/long-operations.module';
import { PipesModule } from 'src/app/common/pipes/pipes.module';
import { FormsConstructorModule } from 'src/app/forms/forms-constructor.module';
import { SharedModule } from 'src/app/shared.module';
import { CardsModule } from 'src/app/views/cards/cards.module';
import { GridUsersListModule } from 'src/app/views/grid-user-list/grid-users-list.module';
import { SortElementsModule } from 'src/app/views/sort-elements/sort-elements.module';
import { TableUsersListModule } from 'src/app/views/table-users-list/table-users-list.module';
import { ViewsModule } from 'src/app/views/views.module';
import { PostsModule } from '../posts/posts.module';
import { CreateProjectComponent } from './create-project/create-project.component';
import { ManageProjectService } from './manage-project.service';
import { ManageProjectComponent } from './project-detail-info/manage-project/manage-project.component';
import { UpdateProjectComponent } from './project-detail-info/manage-project/update-project/update-project.component';
import { ProjectDetailInfoComponent } from './project-detail-info/project-detail-info.component';
import { ProjectInfoComponent } from './project-detail-info/project-info/project-info.component';
import { ProjectsNavigationComponent } from './projects-navigation.component';
import { ProjectsRoutingModule } from './projects-routing.module';
import { ProjectsService } from './projects.service';
import { UserProjectsComponent } from './user-projects/user-projects.component';

@NgModule({
  imports: [
    SharedModule,
    FormsConstructorModule,
    ProjectsRoutingModule,
    PostsModule,
    CardsModule,
    PipesModule,
    ViewsModule,
    TableUsersListModule,
    GridUsersListModule,
    LongOperationModule,
    SortElementsModule,
  ],
  declarations: [
    ProjectsNavigationComponent,
    CreateProjectComponent,
    UserProjectsComponent,
    ProjectDetailInfoComponent,
    ProjectInfoComponent,
    ManageProjectComponent,
    UpdateProjectComponent,
  ],
  providers: [ManageProjectService, ProjectsService],
  exports: [UserProjectsComponent, ProjectDetailInfoComponent, ProjectInfoComponent],
})
export class ProjectsModule {}
